import{jsx as e}from"react/jsx-runtime";import{Fonts as n}from"@vds-core/typography";import{calculateRem as t}from"@vds-core/utilities";import{ColorTokens as i}from"@vds-tokens/color";import{ComponentTokens as o}from"@vds-tokens/component";import{TypographyTokens as r}from"@vds-tokens/typography";import a from"styled-components";const d=function(e,n){return"dark"===e?n?o.calendar.elements.secondary.selected.ondark.value:i.elements.secondary.ondark.value:n?o.calendar.elements.secondary.selected.onlight.value:i.elements.secondary.onlight.value},l=function(e,n,t){switch(e){case 1:return d(n,t);case 2:return"none;";default:return`linear-gradient(180deg, transparent 50%, ${d(n,t)} 50%);`}},s=a.div.withConfig({displayName:"StyledIndicatorWrapper",componentId:"VDS__sc-pcxtlx-0"})`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  transform: translate(-50%, -50%);
  height: ${t(10)};
  padding-top: ${t(2)};
`,c=a.div.withConfig({displayName:"IndicatorOverallWrapper",componentId:"VDS__sc-pcxtlx-1"})`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
`,p=a.span.withConfig({displayName:"Indicator",componentId:"VDS__sc-pcxtlx-2"})`
  border: ${function({surface:e,$isSelected:n}){return`${t(1)} solid ${d(e,n)}`}};
  background: ${function({type:e,surface:n,$isSelected:t}){return l(e,n,t)}};
  box-sizing: border-box;
  height: ${t(8)};
  width: ${t(8)};
  border-radius: 50%;
  margin: 0 ${t(1)};
  display: inline-block;
`,m=a.div.withConfig({displayName:"LegendWrapper",componentId:"VDS__sc-pcxtlx-3"})`
  padding: 0 ${t(14)};
  max-width: 100%;
  max-height: 100%;
  box-sizing: border-box;
  line-height: 1.15;
  > span:last-child {
    padding-right: 0;
  }
`,g=a.span.withConfig({displayName:"Legend",componentId:"VDS__sc-pcxtlx-4"})`
  padding-right: ${t(16)};
  max-width: 100%;
  overflow-x: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  color: ${function({surface:e}){return"dark"===e?i.elements.primary.ondark.value:i.elements.primary.onlight.value}};
  box-sizing: content-box;
  font-size: ${t(r.fontsize.body[12].value)};
  font-family: ${n.VerizonNHGeTX};
  font-weight: ${r.fontweight.regular.value};
  //line-height: ${t(r.lineheight.body[16].value)};
  span {
    white-space: normal;
  }
  &:before {
    content: '';
    border: ${function({surface:e}){return"dark"===e?`${t(1)} solid ${i.elements.secondary.ondark.value}`:`${t(1)} solid ${i.elements.secondary.onlight.value}`}};
    background: ${function({type:e,surface:n,$isSelected:t}){return l(e,n,null!=t&&t)}};
    box-sizing: border-box;
    height: ${t(8)};
    width: ${t(8)};
    border-radius: 50%;
    margin-right: ${t(8)};
    display: inline-block;
  }
`,h=a.div.withConfig({displayName:"LegendContainer",componentId:"VDS__sc-pcxtlx-5"})`
  display: flex;
  align-items: flex-end;
  height: ${t(36)};
  overflow-y: hidden;
  padding-top: ${t(4)};
`,u=function(n){return e(c,{children:e(s,{children:n.children})})};export{p as Indicator,u as IndicatorWrapper,g as Legend,h as LegendContainer,m as LegendWrapper};
